import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/home/logo_ieds.png';
import _imports_1 from '@/assets/img/home/logo_01.png';
import _imports_2 from '@/assets/img/home/logo_04.png';
import _imports_3 from '@/assets/img/home/cardshare.jpeg';
import _imports_4 from '@/assets/img/home/logo_05.png';
import _imports_5 from '@/assets/img/home/ipvsCard.png';
import _imports_6 from '@/assets/img/home/logo_02.png';
import _imports_7 from '@/assets/img/home/chuanliucode.png';
import _imports_8 from '@/assets/img/home/logo_03.png';
import _imports_9 from '@/assets/img/home/user_icon.png';
const _withScopeId = n => (_pushScopeId("data-v-a9b23fda"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "home-header"
};
const _hoisted_3 = {
  class: "head-left"
};
const _hoisted_4 = {
  class: "home-title"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "saas-title"
}, "SaaS 能力", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-title"
}, "营销模版", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-details"
}, "海量数字化展销模板可自由选择", -1));
const _hoisted_8 = [_hoisted_6, _hoisted_7];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-title"
}, "编研模版", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-details"
}, "自由搭配编研模板存管档案", -1));
const _hoisted_11 = [_hoisted_9, _hoisted_10];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-title"
}, "内容编辑器", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-details"
}, "强大的展销内容编辑器，支持全场景编辑", -1));
const _hoisted_14 = [_hoisted_12, _hoisted_13];
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-title"
}, "营销组件", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-details"
}, "多样化的产业营销组件，助力营销", -1));
const _hoisted_17 = [_hoisted_15, _hoisted_16];
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-title"
}, "会务中心", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-details"
}, "一站式会务管理，快速完成活动发布及举办", -1));
const _hoisted_20 = [_hoisted_18, _hoisted_19];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-title"
}, "智慧数字人", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-details"
}, "AI智慧数字人，深度讲解，助力情感化营销，支持定制", -1));
const _hoisted_23 = [_hoisted_21, _hoisted_22];
const _hoisted_24 = {
  class: "saas-body product-body"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "saas-title"
}, "产品矩阵", -1));
const _hoisted_26 = {
  class: "saas-content"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "product-item-content"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "content-title"
}, "川云引擎"), /*#__PURE__*/_createElementVNode("span", {
  class: "content-details"
}, "3D渲染场景专家")], -1));
const _hoisted_29 = [_hoisted_27, _hoisted_28];
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "product-item-content"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "content-title"
}, "川云元宇宙活动"), /*#__PURE__*/_createElementVNode("span", {
  class: "content-details"
}, "新一代元宇宙活动")], -1));
const _hoisted_32 = [_hoisted_30, _hoisted_31];
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "product-item"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", {
  class: "product-item-content"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "content-title"
}, "MeCard"), /*#__PURE__*/_createElementVNode("span", {
  class: "content-details"
}, "元宇宙数字名片")]), /*#__PURE__*/_createElementVNode("div", {
  class: "singe-img mecard-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
})])], -1));
const _hoisted_34 = {
  class: "saas-content product-body"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "product-item"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", {
  class: "product-item-content"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "content-title"
}, "IPVS"), /*#__PURE__*/_createElementVNode("span", {
  class: "content-details"
}, "产业全图谱大数据可视化平台")]), /*#__PURE__*/_createElementVNode("div", {
  class: "singe-img ipvs-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
})])], -1));
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "product-item"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", {
  class: "product-item-content"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "content-title"
}, "川留"), /*#__PURE__*/_createElementVNode("span", {
  class: "content-details"
}, "数字资产管理平台")]), /*#__PURE__*/_createElementVNode("div", {
  class: "singe-img ipvs-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
})])], -1));
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
}, null, -1));
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "product-item-content"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "content-title"
}, "平川党建"), /*#__PURE__*/_createElementVNode("span", {
  class: "content-details"
}, "数字党建新空间")], -1));
const _hoisted_39 = [_hoisted_37, _hoisted_38];
const _hoisted_40 = {
  class: "head-right"
};
const _hoisted_41 = {
  key: 1,
  class: "vh vc"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_43 = {
  class: "login-content"
};
const _hoisted_44 = {
  class: "flex-column vc user-body"
};
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "user-body__img",
  src: _imports_9,
  alt: ""
}, null, -1));
const _hoisted_46 = {
  class: "user-body__phone user-phone"
};
import { userStore } from "@/stores/modules/user";
import { ElMessage } from "element-plus";
import { login } from "@/utils/login";
import notice from "./notice.vue";
import { getPlatformToken } from "@/api/exibition";
import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "headerView"
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["loginDialog", "loginOut"],
  setup(__props, {
    emit
  }) {
    const userState = userStore();
    const router = useRouter();
    const route = useRoute();
    const isLogin = computed(() => {
      return !!toValue(userState.userInfo).token;
    });
    const loginOpen = () => {
      if (route.path !== "/") {
        //当前页不是主页
        login();
        return;
      } else {
        emit("loginDialog", true);
      }
    };
    const handleCommand = command => {
      if (command == "logOut") {
        const newTime = ref(new Date().getTime());
        userState.loginOut();
        router.push({
          name: "home"
        });
        emit("loginOut", newTime.value);
      }
    };
    const linkEvent = type => {
      if (type == "a") {
        // getPlatformToken
        if (userState.userInfo) {
          getTokenFuc(7);
        } else {
          window.open("https://cy.idea888.com/", "_blank");
        }
      } else if (type == "b") {
        window.open("https://meta.idea888.com/", "_blank");
      } else if (type == "c") {
        window.open("https://ieds-test.idea888.com/hiragawa", "_blank");
      }
    };
    const getTokenFuc = _type => {
      getPlatformToken({
        type: _type
      }).then(res => {
        if (_type == 7) {
          window.open(" https://cy.idea888.com?center_token=" + res.data.token, "_blank");
        }
      });
    };
    const openTip = () => {
      ElMessage({
        message: "暂未开放",
        type: "warning"
      });
    };
    const handleBack = () => {
      const url = route.meta.back.url;
      if (url) {
        router.push({
          path: url
        });
      } else {
        //判断history栈堆是否还有元素 没有就返回主页
        if (window.history.state.back) {
          router.back();
        } else {
          router.push({
            name: "home"
          });
        }
      }
    };
    const phoneFormat = computed(() => {
      if (!userState.userInfo.mobile) {
        return;
      }
      function geTel(tel) {
        return tel.substring(0, 3) + "****" + tel.substr(tel.length - 4);
      }
      return geTel(userState.userInfo.mobile);
    });
    const jump = path => {
      router.push({
        path
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_ArrowDown = _resolveComponent("ArrowDown");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_ctx.$route.meta.back ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        onClick: handleBack,
        id: "header-back-btn",
        type: "primary"
      }, {
        default: _withCtx(() => [_createTextVNode("返回")]),
        _: 1
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        class: "logo",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push({
          path: '/'
        })),
        src: _imports_0,
        alt: ""
      }), _createElementVNode("span", {
        class: "home-title",
        style: {
          "margin-right": "64px"
        },
        onClick: _cache[1] || (_cache[1] = $event => jump('/'))
      }, "首页"), _unref(route).path == '/' ? (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 0,
        trigger: "hover",
        "popper-class": "product-content"
      }, {
        dropdown: _withCtx(() => [_createElementVNode("div", {
          class: "saas-body"
        }, [_hoisted_5, _createElementVNode("div", {
          class: "saas-content"
        }, [_createElementVNode("div", {
          onClick: openTip,
          class: "saas-item"
        }, _hoisted_8), _createElementVNode("div", {
          onClick: openTip,
          class: "saas-item"
        }, _hoisted_11), _createElementVNode("div", {
          onClick: openTip,
          class: "saas-item"
        }, _hoisted_14)]), _createElementVNode("div", {
          class: "saas-content"
        }, [_createElementVNode("div", {
          onClick: openTip,
          class: "saas-item"
        }, _hoisted_17), _createElementVNode("div", {
          onClick: openTip,
          class: "saas-item"
        }, _hoisted_20), _createElementVNode("div", {
          onClick: openTip,
          class: "saas-item"
        }, _hoisted_23)])]), _createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", _hoisted_26, [_createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = $event => linkEvent('a')),
          class: "product-item"
        }, _hoisted_29), _createElementVNode("div", {
          onClick: _cache[3] || (_cache[3] = $event => linkEvent('b')),
          class: "product-item"
        }, _hoisted_32), _hoisted_33]), _createElementVNode("div", _hoisted_34, [_hoisted_35, _hoisted_36, _createElementVNode("div", {
          onClick: _cache[4] || (_cache[4] = $event => linkEvent('c')),
          class: "product-item"
        }, _hoisted_39)])])]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createTextVNode("产品矩阵"), _createVNode(_component_el_icon, {
          style: {
            "margin-left": "5px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_ArrowDown)]),
          _: 1
        })])]),
        _: 1
      })) : _createCommentVNode("", true), _unref(route).path == '/' ? (_openBlock(), _createElementBlock("span", {
        key: 1,
        onClick: openTip,
        class: "home-title head-name"
      }, "模版市场")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_40, [_unref(isLogin) && _unref(route).path == '/' ? (_openBlock(), _createElementBlock("p", {
        key: 0,
        onClick: _cache[5] || (_cache[5] = $event => _ctx.$router.push('/workplace/history')),
        class: "home-title"
      }, " 工作台 ")) : _createCommentVNode("", true), !_unref(isLogin) ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createElementVNode("span", {
        onClick: loginOpen,
        class: "home-title"
      }, "注册"), _hoisted_42, _createElementVNode("span", {
        class: "home-title",
        onClick: loginOpen
      }, "登录")])) : _createCommentVNode("", true), _unref(isLogin) ? (_openBlock(), _createBlock(notice, {
        key: 2
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_43, [_unref(isLogin) ? (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 0,
        "popper-class": "login-popper",
        trigger: "hover",
        onCommand: handleCommand
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            command: "logOut"
          }, {
            default: _withCtx(() => [_createTextVNode("退出登录")]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_44, [_hoisted_45, _createElementVNode("p", _hoisted_46, _toDisplayString(_unref(phoneFormat)), 1)])]),
        _: 1
      })) : _createCommentVNode("", true)])])])]);
    };
  }
});